import { FC, SVGProps } from "react";

const CashlessIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="53"
      height="56"
      viewBox="0 0 53 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        opacity=".3"
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="matrix(1 0 0 -1 24 29)"
        fill="#4BB1E9"
      />
      <path
        d="M26.666 16h4a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4h-24a4 4 0 0 1-4-4V20a4 4 0 0 1 4-4h4"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="18.667"
        cy="27.556"
        r="5.622"
        stroke="#2C2C2C"
        strokeWidth="1.2"
      />
      <path
        d="M18.667 24.889v5.333M16 27.555h5.333M7.111 38.222h14.223M7.111 41.778h10.667M7.111 45.333h10.667m8.888-27.263v-3.848c0-.982-.895-1.777-2-1.777h-12c-1.104 0-2 .795-2 1.777v3.906"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.552 18.222h16.115"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <rect
        x="42.381"
        y="45.114"
        width="6.813"
        height="4.921"
        rx=".5"
        transform="rotate(108.465 42.38 45.114)"
        stroke="#2C2C2C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m40.944 44.634-2.098 6.283m-.176-5.447-.24.719"
        stroke="#2C2C2C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.667 35.778a2 2 0 0 1 2-2h7.022a2 2 0 0 1 2 2v15.555a2 2 0 0 1-2 2h-7.022a2 2 0 0 1-2-2V35.778Z"
        fill="#2C2C2C"
      />
      <path
        d="M27.556 36.358a1.69 1.69 0 0 1 1.69-1.691h.32c.264 0 .516.11.697.302.18.192.432.302.696.302h1.84c.263 0 .516-.11.696-.302a.954.954 0 0 1 .697-.302h.697a2 2 0 0 1 2 2v13.777a2 2 0 0 1-2 2h-5.333a2 2 0 0 1-2-2V36.358Z"
        fill="#fff"
      />
      <path
        d="M33.687 49a.321.321 0 0 1-.19-.05.73.73 0 0 1-.13-.12l-2.29-2.62a.582.582 0 0 1-.11-.14.822.822 0 0 1-.02-.21v-.22c0-.067.02-.12.06-.16a.231.231 0 0 1 .17-.07h.54c.467 0 .823-.06 1.07-.18.246-.12.413-.28.5-.48.093-.2.14-.43.14-.69 0-.247-.047-.47-.14-.67a.977.977 0 0 0-.48-.49c-.233-.12-.564-.18-.99-.18h-.73a.253.253 0 0 1-.17-.06.252.252 0 0 1-.06-.17v-.26c0-.067.02-.12.06-.16a.231.231 0 0 1 .17-.07h3.98a.2.2 0 0 1 .16.07.2.2 0 0 1 .07.16v.26a.231.231 0 0 1-.07.17.216.216 0 0 1-.16.06h-1.52l-.25-.27c.433.107.73.31.89.61.16.3.24.647.24 1.04 0 .367-.08.703-.24 1.01-.154.307-.4.553-.74.74-.334.18-.764.277-1.29.29l-.3.01.01-.4 2.56 2.94c.053.053.08.103.08.15 0 .053-.02.093-.06.12a.264.264 0 0 1-.15.04h-.61Zm-2.6-4.68a.23.23 0 0 1-.17-.06.23.23 0 0 1-.06-.17v-.25c0-.073.02-.13.06-.17a.253.253 0 0 1 .17-.06h3.98c.066 0 .12.02.16.06.047.04.07.097.07.17v.25c0 .073-.023.13-.07.17a.216.216 0 0 1-.16.06h-3.98Z"
        fill="#2C2C2C"
      />
    </svg>
  );
};

export default CashlessIcon;
